import type {
  MaterialStockDto,
  StockLocationDto,
  StockMovementDto,
} from "@grizzly/shared";
import { request } from "../http.js";

export const inventoryApi = {
  listStockLocations: () => request<{ items: StockLocationDto[] }>("/stock-locations"),
  createStockLocation: (input: object) =>
    request<{ location: StockLocationDto }>("/stock-locations", {
      method: "POST",
      body: input,
    }),
  listStock: () => request<{ items: MaterialStockDto[] }>("/stock"),
  getMaterialStock: (materialId: string) =>
    request<{ stock: MaterialStockDto }>(`/stock/${materialId}`),
  listStockMovements: (materialId: string) =>
    request<{ items: StockMovementDto[] }>(`/stock/${materialId}/movements`),
  adjustStock: (input: object) =>
    request<{ movement: StockMovementDto }>("/stock/adjust", {
      method: "POST",
      body: input,
    }),
  issueStock: (input: object) =>
    request<{ movement: StockMovementDto }>("/stock/issue", {
      method: "POST",
      body: input,
    }),
  returnStock: (input: object) =>
    request<{ movement: StockMovementDto }>("/stock/return", {
      method: "POST",
      body: input,
    }),
  reverseStockMovement: (movementId: string, reason: string) =>
    request<{ movement: StockMovementDto }>(`/stock/movements/${movementId}/reverse`, {
      method: "POST",
      body: { reason },
    }),
};
